import { render } from "./MenuCabecera.vue?vue&type=template&id=063a41ee&scoped=true"
import script from "./MenuCabecera.vue?vue&type=script&lang=js"
export * from "./MenuCabecera.vue?vue&type=script&lang=js"

import "./MenuCabecera.vue?vue&type=style&index=0&id=063a41ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063a41ee"]])

export default __exports__